import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Loader from '../componentsII/Loader';
import { AlertTriangle } from 'lucide-react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogContentText,
  DialogActions,
  Button,
  Box
} from '@mui/material';
import { Alert } from '@mui/material';

const ProtectedRouteByCompanyDetails = ({ children }) => {
  const [restrictAccessByCompanyDetails, setRestrictAccessByCompanyDetails] = useState(true);
  const [loading, setLoading] = useState(true);
  const [showWarning, setShowWarning] = useState(false);
  const [shouldNavigate, setShouldNavigate] = useState(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user')) || { company: { id: null, name: null } };

    if(user.role_code === 'ADMIN') {
      setRestrictAccessByCompanyDetails(false);
      setShowWarning(false);
      setShouldNavigate(true);
      return;
    }

    if (user.company.id && user.company.name) {
      setRestrictAccessByCompanyDetails(false);
    } else {
      setRestrictAccessByCompanyDetails(true);
      setShowWarning(true);
    }

    setLoading(false);
  }, []);

  const handleConfirm = () => {
    setShowWarning(false);
    setShouldNavigate(true);
  };

  if (loading) {
    return <Loader />;
  }

  if (shouldNavigate) {
    return <Navigate to="/account/company-details" />;
  }

  if (restrictAccessByCompanyDetails) {
    return (
      <Dialog
      open={showWarning}
      onClose={() => {}}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 1
        }
      }}
    >
      <DialogTitle sx={{ 
        fontSize: '1.5rem',
        fontWeight: 600,
        pt: 2,
        pb: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}>
        <AlertTriangle size={24} color="#ff9800" /> {/* Warning icon */}
        Company Details Required
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          <DialogContentText sx={{ color: 'text.primary' }}>
            Please complete your company details to access other menus. You will be redirected to the company details page.
          </DialogContentText>
        </Alert>
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 1 }}>
        <Button
          variant="contained"
          onClick={handleConfirm}
          sx={{
            textTransform: 'none',
            px: 3,
            py: 1,
            borderRadius: 1,
            backgroundColor: '#ff9800',
            '&:hover': {
              backgroundColor: '#fb8c00',
            }
          }}
        >
          Continue to Company Details
        </Button>
      </DialogActions>
    </Dialog>
    );
  }

  return children;
};

export default ProtectedRouteByCompanyDetails;